import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppInitializer } from './app-initializer';
import { GuestService } from './shared/services/guest.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'seat-widget';
  loader: boolean;
  bannerImg = '';
  logoImg = '';
  backgroundImg = '';
  widgetSettings: any = {};

  constructor(
    private appIntializer: AppInitializer,
    public gs: GuestService,
    private spinner: NgxSpinnerService
  ) {

    const configSettings = this.appIntializer.appConfigSettings();
    this.gs.ConfigSettings = configSettings;
    this.gs.loader.subscribe(val => {
      if (val) {
        this.spinner.show();
        this.loader = true;
      } else {
        this.loader = false;
        this.spinner.hide();
      }
    });

    this.gs.merchantImgUrl.subscribe((images: any) => {
      this.bannerImg = images.bannerImg;
      this.logoImg = images.logoImg;
      this.backgroundImg = images.backgroundImg;
    });

  }

  ngOnInit() {
    this.gs.widgetConfigurations.subscribe(config => { this.widgetSettings = config });
  }
}

